"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerGuard = exports.device = exports.weixin = exports.encryptText = exports.encryptTransfer = exports.wxpay = exports.clearSecirtyCheckCache = exports.startAndCheck = exports.saveDeviceBind = exports.comTest = exports.securityPlugin = exports.loginUtil = exports.checkWxLogin = exports.WeixinPage = exports.AreaCodePage = exports.SecurityPage = exports.SecurityCode = void 0;
var typings_1 = require("./typings");
Object.defineProperty(exports, "SecurityCode", { enumerable: true, get: function () { return typings_1.SecurityCode; } });
class SecurityPage {
    constructor(option, getSafeInfo) {
        throw new Error('please use webpack externals!');
    }
    async invoke() {
        throw new Error('please use webpack externals!');
    }
}
exports.SecurityPage = SecurityPage;
class AreaCodePage {
    constructor() {
        throw new Error('please use webpack externals!');
    }
    async invoke(itemFilter) {
        throw new Error('please use webpack externals!');
    }
}
exports.AreaCodePage = AreaCodePage;
class WeixinPage {
    constructor() {
        throw new Error('please use webpack externals!');
    }
    async invoke(opt) {
        throw new Error('please use webpack externals!');
    }
}
exports.WeixinPage = WeixinPage;
/**
 * 提供给 vue-router 使用的路由守护
 * @param state
 * @param noBind 无需绑定富融账户
 */
const checkWxLogin = (toRoute) => {
    throw new Error('please use webpack externals!');
};
exports.checkWxLogin = checkWxLogin;
exports.loginUtil = {
    wxCheckLogin: (toRoute) => {
        throw new Error('please use webpack externals!');
    },
    wxReLogin: () => {
        throw new Error('please use webpack externals!');
    },
    wxLogin: (type, params) => {
        throw new Error('please use webpack externals!');
    },
};
exports.securityPlugin = {
    install: () => {
        throw new Error('please use webpack externals!');
    },
};
function comTest(key, props) {
    throw new Error('please use webpack externals!');
}
exports.comTest = comTest;
/**
 * 把设备绑定ID写入 localstore
 * @param deviceBindId
 */
function saveDeviceBind(bindAction) {
    throw new Error('please use webpack externals!');
}
exports.saveDeviceBind = saveDeviceBind;
/**
 * 启动安全会话并校验
 * 返回 code === 0 代表验证通过
 * code === 1 代表用户主动取消操作
 * code === 2 代表验证失败(比如接口异常, 密码错误次数过多锁定等等)
 * @param verifyType 安全场景值, 找安全中心中台申请
 * @param options
 */
async function startAndCheck(verifyType, 
/**
 * 调用来源
 */
source) {
    throw new Error('please use webpack externals!');
}
exports.startAndCheck = startAndCheck;
/**
 * 清理安全校验会话标记
 * @param verifyType
 */
function clearSecirtyCheckCache(verifyType) {
    throw new Error('please use webpack externals!');
}
exports.clearSecirtyCheckCache = clearSecirtyCheckCache;
/**
 * 拉起微信支付
 * 这 api 不会有任何返回
 * 业务方需要实现一个 h5_redirect_url 作为支付结果页
 * 所有入参都由预下单接口返回
 * @param option
 */
async function wxpay(option) { }
exports.wxpay = wxpay;
/**
 * 基于 RSA 保护的密钥协商通信
 * @returns
 */
async function encryptTransfer() {
    throw new Error('please use webpack externals!');
}
exports.encryptTransfer = encryptTransfer;
function encryptText(text) {
    throw new Error('please use webpack externals!');
}
exports.encryptText = encryptText;
exports.weixin = {
    /**
     * 校验当前用户是否完成账户关联
     * @param loginSource 业务来源, 可能的取值包括 walletLoan, easyDeposit
     * @returns 返回 true 代表已经关联, false 代表未关联
     */
    checkAssociation: (loginSource) => {
        return Promise.resolve(true);
    },
    /**
     * 执行账户关联逻辑
     * @param loginSource 业务来源, 可能的取值包括 walletLoan, easyDeposit
     * @returns 返回 true 代表已经关联, false 代表未关联
     */
    association: (loginSource, btnText) => {
        return Promise.resolve(true);
    },
    wxCheckLogin: exports.loginUtil.wxCheckLogin,
    wxReLogin: exports.loginUtil.wxReLogin,
    wxLogin: exports.loginUtil.wxLogin,
    wxpay,
    userInfo: (bussId, bussType) => {
        throw new Error('please use webpack externals!');
    },
    loginMobile: () => {
        throw new Error('please use webpack externals!');
    },
};
exports.device = {
    /**
     * - 设置设备绑定校验 flag
     * - 对外暴露给 vb-web-account 的账户关联流程使用
     */
    setDeviceCheckFlag: () => {
        throw new Error('please use webpack externals!');
    },
    deviceRebind(source) {
        throw new Error('please use webpack externals!');
    },
};
/**
 * 路由守护
 */
exports.routerGuard = {
    /**
     * 简单授权登录
     * 用于把 unionid 放入 Session
     * 不会产生 gid/uid
     */
    checkLoginUnion: () => {
        throw new Error('please use webpack externals!');
    },
};
